
import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { HomeIcon, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Update document title
    document.title = "Page Not Found | Payton Hunter";
    
    // Log error for analytics
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Page Not Found | Payton Hunter</title>
        <meta name="description" content="The page you were looking for doesn't exist. You may have mistyped the address or the page may have moved." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center bg-sage-50/50 py-16 px-4">
        <div className="max-w-md w-full bg-white shadow-lg rounded-xl p-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sage-100 text-sage-700 mb-6">
            <span className="text-2xl font-semibold">404</span>
          </div>
          
          <h1 className="text-2xl font-serif text-sage-800 mb-4">Page Not Found</h1>
          
          <p className="text-gray-600 mb-8">
            The page you were looking for doesn't exist. You may have mistyped the address or the page may have moved.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild variant="default" className="bg-sage-700 hover:bg-sage-800 w-full sm:w-auto">
              <Link to="/" className="flex items-center">
                <HomeIcon className="mr-2 h-4 w-4" /> Return Home
              </Link>
            </Button>
            
            <Button asChild variant="outline" className="w-full sm:w-auto">
              <Link to="#" onClick={() => window.history.back()} className="flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
              </Link>
            </Button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
